<template>
    <div>
        <div class="row">
            <div class="col-lg-4 col-12" style="z-index:9999;">
                <inventory-export></inventory-export>
            </div>
            <div class="col-lg-8 col-12" style="z-index:9999;">
                <repair-export></repair-export>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-12 col-12">
                <repairs-table></repairs-table>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-lg-12 col-12">
                <repair-stats-table></repair-stats-table>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-lg-4 col-12">
                <repair-export></repair-export>
            </div>
        </div> -->
        <div class="row">
            <div class="col-12">
                <RepairsIdlePerPeriodByASF></RepairsIdlePerPeriodByASF>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-12">
                <earlykit-parts-table></earlykit-parts-table>
            </div>
            <div class="col-lg-6 col-12">
                <parts-used-bar-chart></parts-used-bar-chart>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 col-12"></div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-12">
                <repair-warranty-pie-chart></repair-warranty-pie-chart>
            </div>
            <div class="col-lg-6 col-12">
                <repair-equipment-bar-chart></repair-equipment-bar-chart>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-12">
                <errors-bar-chart></errors-bar-chart>
            </div>
            <div class="col-lg-6 col-12">
                <RepairsPerMonthByASF></RepairsPerMonthByASF>
            </div>
        </div>
    </div>
</template>
<script>
import InventoryExport from "./dashboard/InventoryExport";
import RepairExport from "./dashboard/RepairExport";
import RepairStatsTable from "./dashboard/RepairStatsTable";
import EarlykitPartsTable from "./dashboard/EarlykitPartsTable";
import RepairEquipmentBarChart from "./dashboard/RepairEquipmentBarChart";
import ErrorsBarChart from "./dashboard/ErrorsBarChart";
import PartsUsedBarChart from "./dashboard/PartsUsedBarChart";
import RepairWarrantyPieChart from "./dashboard/RepairWarrantyPieChart";
import RepairsPerMonthByASF from "./dashboard/RepairsPerMonthByASF";
import RepairsTable from "./dashboard/RepairsTable";
import RepairsIdlePerPeriodByASF from "./dashboard/RepairsIdlePerPeriodByASF";
export default {
  components: {
    InventoryExport,
    RepairExport,
    RepairStatsTable,
    EarlykitPartsTable,
    RepairEquipmentBarChart,
    RepairWarrantyPieChart,
    RepairsTable,
    ErrorsBarChart,
    PartsUsedBarChart,
    RepairsPerMonthByASF,
    RepairsIdlePerPeriodByASF
  },
  data() {
    return {
      columns: ["repair_id", "name", "model_name", "status_name", "id"],
      options: {
        perPage: 5,
        perPageValues: [],
        headings: {
          repair_id: "Repair #",
          name: "ASF",
          model_name: "Model",
          status_name: "Status",
          id: ""
        },
        skin: "table table-xs table-hover",
        pagination: {
          edge: true
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  }
};
</script>
<style></style>
